/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type AggregateVariable = (typeof AggregateVariable)[keyof typeof AggregateVariable];

export const AggregateVariable = {
  n_interactions: 'n_interactions',
  n_topics: 'n_topics',
  n_topics_conversations: 'n_topics_conversations',
  n_negative_intent_v2: 'n_negative_intent_v2',
  n_intents: 'n_intents',
  n_user_actions: 'n_user_actions',
  n_user_actions_conversations: 'n_user_actions_conversations',
  n_keywords: 'n_keywords',
  n_emotions: 'n_emotions',
  n_data_sources: 'n_data_sources',
  emotions: 'emotions',
  n_users: 'n_users',
  user_feedback_v2: 'user_feedback_v2',
  conversation_user_feedback: 'conversation_user_feedback',
  interaction_negative_feedback_v2: 'interaction_negative_feedback_v2',
  percentage_negative_feedback: 'percentage_negative_feedback',
  conversation_percentage_negative_feedback: 'conversation_percentage_negative_feedback',
  percentage_negative_feedback_explicit: 'percentage_negative_feedback_explicit',
  conversation_percentage_negative_feedback_explicit: 'conversation_percentage_negative_feedback_explicit',
  cost: 'cost',
  latency_seconds: 'latency_seconds',
  session_length: 'session_length',
  session_time: 'session_time',
  n_sessions: 'n_sessions',
  n_segments: 'n_segments',
  start_session: 'start_session',
  end_session: 'end_session',
  retention: 'retention',
  topics: 'topics',
  topics_conversations: 'topics_conversations',
  conversation_labels: 'conversation_labels',
  sentiment_score: 'sentiment_score',
  conversation_sentiment_score: 'conversation_sentiment_score',
  tags: 'tags',
  n_positive_messages: 'n_positive_messages',
  n_negative_messages: 'n_negative_messages',
  conversation: 'conversation',
  conversation_sample: 'conversation_sample',
  users: 'users',
  bounce_rate: 'bounce_rate',
  sort_percentage: 'sort_percentage',
  conversation_custom_aggregates: 'conversation_custom_aggregates',
  penetration: 'penetration',
  user_rating: 'user_rating',
  aifi_score: 'aifi_score',
  aifi_task_clarity_score: 'aifi_task_clarity_score',
  aifi_context_provision_score: 'aifi_context_provision_score',
  aifi_output_specification_score: 'aifi_output_specification_score',
  aifi_prompt_length_score: 'aifi_prompt_length_score',
  aifi_conversation_efficiency_score: 'aifi_conversation_efficiency_score',
  aifi_constraint_specification_score: 'aifi_constraint_specification_score',
  aifi_proficiency_moved_up: 'aifi_proficiency_moved_up',
  aifi_proficiency_slipped_back: 'aifi_proficiency_slipped_back',
  aifi_proficiency_stayed: 'aifi_proficiency_stayed',
  conversation_custom_columns: 'conversation_custom_columns',
  conversation_id: 'conversation_id',
  conversation_error_status: 'conversation_error_status',
  roi_hours_saved: 'roi_hours_saved',
  roi_hours_saved_per_user: 'roi_hours_saved_per_user',
  roi_hours_saved_per_interaction: 'roi_hours_saved_per_interaction',
  roi_successful_interactions: 'roi_successful_interactions',
  roi_success_rate: 'roi_success_rate',
  roi_value_saved: 'roi_value_saved',
  roi_value_saved_per_interaction: 'roi_value_saved_per_interaction',
  dropoff_sentiment: 'dropoff_sentiment',
  processed_n_interactions: 'processed_n_interactions',
  last_upload_date: 'last_upload_date',
  input_length: 'input_length',
  output_length: 'output_length',
  input_tokens: 'input_tokens',
  output_tokens: 'output_tokens',
  total_users: 'total_users',
  potential_savings: 'potential_savings',
  scaled_cost: 'scaled_cost',
  most_used_provider: 'most_used_provider',
  most_used_modality: 'most_used_modality',
} as const;
